<template>
    <div class="xcard">
        <v-btn v-if="showvolver" small class="ma-0" @click="$router.back()" color="info" outlined> 
            <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras 
        </v-btn>
        <h3 class="text-center my-0"> Programas de oferta libre </h3>
        
        <v-divider class="mt-0 mb-4" />
        <v-btn color="blue" small outlined dark :loading="loading" @click="getDatos()"> <v-icon>mdi-refresh</v-icon> </v-btn>

        <v-data-table :headers="headers" :items="desserts" :loading="loading"  dense disable-pagination  hide-default-footer :items-per-page="50" class="elevation-0">
    
            <template v-slot:[`item.ind`]="a">
                <span> {{ a.index + 1 }} </span>
            </template>
            <template v-slot:[`item.proyecto_fecha_aprobacion`]="{item}">
                <span> {{ parseFecha(item.proyecto_fecha_aprobacion) }} </span>
            </template>
            <template v-slot:[`item.fecha_inicio`]="{item}">
                <span> {{ parseFecha(item.fecha_inicio) }} </span>
            </template>
            <template v-slot:[`item.fecha_fin`]="{item}">
                <span> {{ parseFecha(item.fecha_fin) }} </span>
            </template>
            <template v-slot:[`item.disponible_para_oferta`]="{item}">
                <p class="text-center ma-0" >
                    <v-badge dot :color="item.disponible_para_oferta?'green':'red'" />
                </p>
            </template>
            
            <template v-slot:[`item.opt`]="{item}">
                <v-menu offset-x offset-y>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn class="my-0 py-0" color="primary" outlined small dark v-bind="attrs" v-on="on">
                            <v-icon>mdi-menu</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item v-if="item.disponible_para_oferta" link @click="crearPrograma(item)">
                            <v-list-item-title>
                                <v-icon>mdi-plus</v-icon>
                                Crear programa
                            </v-list-item-title>
                        </v-list-item> 
                    </v-list>
                </v-menu> 
            </template>

        </v-data-table>

    </div>
</template>
  
<script>
import xaxios from '@/xaxios';
import {parseFecha, meses} from '../util.ts'
import {getPosgrado} from '@/views/oferta_academica/autoria/utils.ts'

export default {
    components: {},
    props:{
        showvolver:{type:Boolean, default: true},
        isgeneral:{type:Boolean, default: false},
    },
    data() {
        return {
            loading: false,
            headers: [ 
                { text: '#', value: 'ind' },
                { text: 'Programa', value: 'programa_nombre', width:'350' },
                { text: 'Sede origen', value: 'sede', width:'125' },
                { text: 'Aprobacion', value: 'proyecto_fecha_aprobacion' },
                { text: 'Resolucion', value: 'resolucion_aprobacion_universidad' },
                { text: 'Fecha inicio', value: 'fecha_inicio' },
                { text: 'Fecha fin', value: 'fecha_fin' },
                { text: 'Aperturas', value: 'programas_aperturados' },
                { text: '', value: 'opt' },
            ],
            desserts: [],
            parseFecha,
            meses,
            gestiones:[],
            filtros:{
                mes:null,
                anio: null,
            }
        };
    },
    watch: {
        '$store.state.CARGO': function(a,b){ 
            const aa = a.sede.unidad_negocio;
            const bb = b.sede.unidad_negocio;
            if(aa == bb){
                return;
            }
            this.getDatos();
        }, 
    },
    methods: {
        async getDatos(){ 
            const unidad = this.$store.state.CARGO.sede.unidad_negocio;
            const ps = `ofertas-academicas/oferta-libre?unidad_negocio_id=${unidad}`;
            const url = process.env.VUE_APP_URL_API_PAGOS2+ps;
            this.desserts = [];
            this.loading = true;
            const res = await xaxios.get(url).then(({data})=>data).catch(e=>e);
            window.console.log('res', res);
            if(res) {
                this.desserts = res.datos;
            }
            this.loading = false;
        },

        async crearPrograma(proy){
            const ispermitido = this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 5 || this.$store.state.CARGO.id == 6;
            if(!ispermitido){
                this.$root.$notify.show('no tiene autorizacion.', {color:'red',x: 'right',timeout:1800});
                return;
            }
            const item = await getPosgrado(this,proy.postgrado_id)
            
            this.$store.dispatch('postgrado/selectPostgrado', item);
            window.sessionStorage.setItem('xpostgradorest', JSON.stringify(item));
            this.$router.push({ name: 'programaviewrest' });
           
        }
    },
    mounted() {
        this.getDatos();
        if(this.isgeneral){
            const b = { text: 'ofertar', value: 'disponible_para_oferta' };
            this.headers.splice(7, 0, b);
        }
    },
};
</script>
  